export const exportData = (fetchedData: any) => {
  const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
    JSON.stringify(fetchedData, null, 4) // Indent with 4 spaces for beautification
  )}`;
  const link = document.createElement('a');
  link.href = jsonString;
  link.download = 'data.json';
  link.click();
};
